import { useCallback } from "react";
import { useUser, useClerk } from "@/lib/clerkShim";
import { queryClient } from "@/lib/queryClient";

export const useAuth = () => {
  const { user, isLoaded } = useUser();
  const { signOut: clerkSignOut } = useClerk();

  const signOut = useCallback(async () => {
    queryClient.clear();
    await clerkSignOut();
  }, [clerkSignOut]);

  return { user: user ?? null, loading: !isLoaded, signOut };
};
